// @flow

import { action, observable } from "mobx";

import Store from "app/stores/Store";
import AppearanceStore from "app/stores/AppearanceStore";
import VideoStore from "app/stores/VideoStore";
import VideoService from "app/services/VideoService";
import Video from "app/models/Video";
import FolderStore from "app/stores/FolderStore";
import Folder from "app/models/Folder";

class VideoFolderMoveStore extends Store {
    @observable video: ?Video;
    @observable isEditing: boolean = false;

    @action.bound
    startEditing(video: Video) {
        this.video = video;
        this.isEditing = true;
    }

    @action.bound
    cancelEditing() {
        this.video = null;
        this.isEditing = false;
    }

    @action.bound
    saveFolder(folderId: Number) {
        const promise = VideoService.updateFolder(this.video.uid, folderId);

        return promise.then(({data}) => {
            this.onSaved(data);
        })
        .catch((err) => {
            AppearanceStore.notifyError(err.data.message);
        });
    }

    @action.bound
    onSaved(data: any) {
        VideoStore.updateLastSaved();
        FolderStore.setFolders(Folder.makeArray(data.folders));
        VideoStore.updateVideo(Video.make(data.video));
        this.cancelEditing();
        AppearanceStore.notifySuccess(
            "Folder updated successfully"
        );
    }
}

export default new VideoFolderMoveStore();



// WEBPACK FOOTER //
// ./src/app/stores/VideoFolderMoveStore.js